import React from 'react'
import MaskedInput from 'react-text-mask'
function InputCPF({ value, onChange, disabled = false }) {

    const mask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    return (
        <MaskedInput disabled={disabled} inputMode='numeric' mask={mask} placeholder='000.000.000-00' className="form-control" value={value} onChange={value => {
            onChange(value.target.value)
        }}></MaskedInput>)
}

export default InputCPF